const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

const PROJECT_CHILD_SEGMENTS = new Set([
  "new",
  "script",
  "characters",
  "schedule",
  "budget",
  "settings",
]);

const isDynamicSegment = (segment: string, prev: string | undefined): boolean => {
  if (UUID_RE.test(segment)) {
    return true;
  }

  if (prev === "workspaces") {
    return true;
  }

  if (prev === "projects") {
    return !PROJECT_CHILD_SEGMENTS.has(segment);
  }

  if (prev === "compare" || prev === "snapshots" || prev === "actors") {
    return true;
  }

  if (prev === "reset_password" || prev === "join" || prev === "verify_account") {
    return true;
  }

  return false;
};

/** Collapses dynamic URL segments into stable templates for PostHog Web Analytics grouping. */
export const buildAnalyticsPathTemplate = (pathname: string): string => {
  if (!pathname || pathname === "/") {
    return "/";
  }

  const segments = pathname.split("/").filter(Boolean);
  const templated = segments.map((segment, index) => {
    const prev = index > 0 ? segments[index - 1] : undefined;

    if (!isDynamicSegment(segment, prev)) {
      return segment;
    }

    if (prev === "workspaces") return ":workspaceId";
    if (prev === "projects") return ":projectId";
    if (prev === "compare" || prev === "snapshots") return ":snapshotId";
    if (prev === "actors") return ":actorId";
    if (prev === "reset_password" || prev === "join") return ":token";
    if (prev === "verify_account") return ":status";

    return ":id";
  });

  return `/${templated.join("/")}`;
};
